import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isRequiredIf from 'react-proptype-conditional-require';

import Banner from '@deliveroo/consumer-component-library/components/Banner';
import { getNotification } from '../../selectors/notificationSelectors';
import { clearNotification } from '../../actions/notificationActions';

import styles from './styles.scss';

class Notification extends React.PureComponent {
  componentDidMount() {
    this.setBannerTimeout();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showNotification) {
      this.setBannerTimeout();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  setBannerTimeout() {
    const { showNotification, onTimeout, timeoutDuration } = this.props;

    if (showNotification) {
      this.timeout = setTimeout(onTimeout, timeoutDuration);
    }
  }

  render() {
    const { type, message, showNotification } = this.props;

    if (!showNotification) {
      return null;
    }

    return (
      <div className={styles.wrapper}>
        <Banner type={type}>{message}</Banner>
      </div>
    );
  }
}

Notification.propTypes = {
  message: isRequiredIf(PropTypes.string, (props) => props.showNotification),
  onTimeout: PropTypes.func.isRequired,
  showNotification: PropTypes.bool.isRequired,
  timeoutDuration: PropTypes.number,
  type: isRequiredIf(PropTypes.string, (props) => props.showNotification),
};

Notification.defaultProps = {
  timeoutDuration: 5000,
  message: null,
  type: null,
};

const mapStateToProps = (state) => {
  const { message, showNotification, type } = getNotification(state);

  return {
    message,
    showNotification,
    type,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onTimeout: () => dispatch(clearNotification),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notification);
